import { defineStore } from 'pinia'
import { JOIN_STATUS } from '@/views/components/partner-join/common/data'
import { TOKEN } from '@/constants/storage'
import router from '@/router'
import accountManageApi from '@/apis/account-manage'
import Storage from '@/utils/storage'
import { broadcastChannel } from '@/utils/window-event'
import websocket from '@/websocket/index.js'

// 是否已监听 mqtt 断开事件
let disconnectListening = false

export const useUserStore = defineStore('user', {
  state: () => ({
    isLogined: false, // 是否已经登录
    userInfo: {}, // 登录返回的用户信息
    accountInfo: null, // 账户信息
    promoteRecordUpdateTime: '', // 推广记录数据更新时间
    mqttStatus: 'disconnected', // mqtt 连接状态, disconnected(未连接)/connecting(连接中)/connected(已连接)
  }),
  getters: {
    userId: (state) => state.userInfo.id,
    // 归一化入驻状态 0-未入驻，1入驻中，2已入驻
    joinState: (state) => {
      let status = state.accountInfo?.status
      let flag = null //
      if ([JOIN_STATUS.PAY_CANCEL, JOIN_STATUS.REJECT_CANCEL, JOIN_STATUS.WAIT_SUBMIT].includes(status)) {
        flag = 0
      } else if (status === JOIN_STATUS.SUCCESS) {
        flag = 2
      } else {
        flag = 1
      }
      return flag
    },
  },
  actions: {
    // 登录状态
    setIsLogined(payload) {
      this.isLogined = payload
    },
    // 退出
    logout(path) {
      this.isLogined = false
      Storage.remove(TOKEN)
      this.userInfo = {}
      broadcastChannel.postMessage()
      // 重定向
      if (path) {
        router.replace(path)
      }
    },
    // 设置用户信息
    setUserInfo(params) {
      this.userInfo = params || {}
    },
    // 设置账户信息
    setAccountInfo(params) {
      this.accountInfo = params
    },
    // 设置推广记录数据更新时间
    setPromoteRecordUpdateTime(params) {
      this.promoteRecordUpdateTime = params
    },
    // 连接 mqtt
    async connectMqtt() {
      if (this.mqttStatus !== 'disconnected') {
        return
      } else if (!disconnectListening) {
        websocket.on('disconnect', () => {
          this.mqttStatus = 'disconnected'
        })
        disconnectListening = true
      }
      this.mqttStatus = 'connecting'
      try {
        await websocket.connect()
        this.mqttStatus = 'connected'
      } catch (e) {
        console.log(e)
        this.mqttStatus = 'disconnected'
        throw e
      }
    },

    // 连接 mqtt
    disconnectMqtt() {
      websocket.disconnect()
      this.mqttStatus = 'disconnected'
      // context.commit('setMqttStatus', 'disconnected')
    },
    //查询基本信息与入驻信息
    async getAccountInfo() {
      const res = await accountManageApi.queryAccountInfo({})
      this.accountInfo = res
      return res
    },
  },
  persist: {
    storage: localStorage,
    pick: ['isLogined', 'userInfo', 'accountInfo'],
  },
})
